module.exports = require("openapi-sampler");